export enum EnumComparison {
	GREATER_THAN ='GREATER_THAN', LESS_THAN = 'LESS_THAN', EQUALS = 'EQUALS'
}
